import { Variant } from 'components/Toasts/Toast'
import { createContext, ReactNode } from 'react'
import noop from 'utils/noop'

export type ToastId = string & {
  readonly __tag: unique symbol
}

export interface ToastObject {
  id: ToastId
  message: ReactNode
  variant: Variant
  autoDismiss?: boolean
}

export interface ToastContextValues {
  showToast: (
    message: ReactNode,
    variant?: Variant,
    autoDismiss?: boolean
  ) => ToastId | void
  dismissToast: (id: ToastId) => void
  toasts: ToastObject[]
}

const ToastContext = createContext<ToastContextValues>({
  showToast: noop,
  dismissToast: noop,
  toasts: [],
})

export default ToastContext
